export default "__VITE_ASSET__v3Vv$_iK__"